/**
 * Do not edit directly
 * Generated on Mon, 03 Apr 2023 15:44:15 GMT
 */

module.exports = {
  "breakpoint": {
    "xs": {
      "value": "0px",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "0px"
      },
      "name": "BreakpointXs",
      "attributes": {
        "category": "breakpoint",
        "type": "xs"
      },
      "path": [
        "breakpoint",
        "xs"
      ]
    },
    "md": {
      "value": "672px",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "672px"
      },
      "name": "BreakpointMd",
      "attributes": {
        "category": "breakpoint",
        "type": "md"
      },
      "path": [
        "breakpoint",
        "md"
      ]
    },
    "lg": {
      "value": "1024px",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "1024px"
      },
      "name": "BreakpointLg",
      "attributes": {
        "category": "breakpoint",
        "type": "lg"
      },
      "path": [
        "breakpoint",
        "lg"
      ]
    },
    "xl": {
      "value": "1200px",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "1200px"
      },
      "name": "BreakpointXl",
      "attributes": {
        "category": "breakpoint",
        "type": "xl"
      },
      "path": [
        "breakpoint",
        "xl"
      ]
    }
  },
  "color": {
    "ref": {
      "light": {
        "primary": {
          "5": {
            "value": "#000e19",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#000E19"
            },
            "name": "ColorRefLightPrimary5",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "5"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "5"
            ]
          },
          "10": {
            "value": "#001c34",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#001C34"
            },
            "name": "ColorRefLightPrimary10",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "10"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "10"
            ]
          },
          "20": {
            "value": "#002c53",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#002C53"
            },
            "name": "ColorRefLightPrimary20",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "20"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "20"
            ]
          },
          "30": {
            "value": "#003e74",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#003E74"
            },
            "name": "ColorRefLightPrimary30",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "30"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "30"
            ]
          },
          "40": {
            "value": "#004e93",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#004E93"
            },
            "name": "ColorRefLightPrimary40",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "40"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "40"
            ]
          },
          "50": {
            "value": "#005eaf",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#005EAF"
            },
            "name": "ColorRefLightPrimary50",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "50"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "50"
            ]
          },
          "60": {
            "value": "#006bc8",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#006BC8"
            },
            "name": "ColorRefLightPrimary60",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "60"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "60"
            ]
          },
          "70": {
            "value": "#0f7ddc",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#0F7DDC"
            },
            "name": "ColorRefLightPrimary70",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "70"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "70"
            ]
          },
          "80": {
            "value": "#3f9bec",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#3F9BEC"
            },
            "name": "ColorRefLightPrimary80",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "80"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "80"
            ]
          },
          "90": {
            "value": "#7abcf7",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#7ABCF7"
            },
            "name": "ColorRefLightPrimary90",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "90"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "90"
            ]
          },
          "95": {
            "value": "#bcdffd",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#BCDFFD"
            },
            "name": "ColorRefLightPrimary95",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "95"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "95"
            ]
          },
          "99": {
            "value": "#deeffe",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#DEEFFE"
            },
            "name": "ColorRefLightPrimary99",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "99"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "99"
            ]
          },
          "100": {
            "value": "#ffffff",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FFFFFF"
            },
            "name": "ColorRefLightPrimary100",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "primary",
              "state": "100"
            },
            "path": [
              "color",
              "ref",
              "light",
              "primary",
              "100"
            ]
          }
        },
        "success": {
          "5": {
            "value": "#001910",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#001910"
            },
            "name": "ColorRefLightSuccess5",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "5"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "5"
            ]
          },
          "10": {
            "value": "#003420",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#003420"
            },
            "name": "ColorRefLightSuccess10",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "10"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "10"
            ]
          },
          "20": {
            "value": "#005333",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#005333"
            },
            "name": "ColorRefLightSuccess20",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "20"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "20"
            ]
          },
          "30": {
            "value": "#007447",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#007447"
            },
            "name": "ColorRefLightSuccess30",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "30"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "30"
            ]
          },
          "40": {
            "value": "#00935b",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#00935B"
            },
            "name": "ColorRefLightSuccess40",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "40"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "40"
            ]
          },
          "50": {
            "value": "#00af6c",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#00AF6C"
            },
            "name": "ColorRefLightSuccess50",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "50"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "50"
            ]
          },
          "60": {
            "value": "#00c87b",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#00C87B"
            },
            "name": "ColorRefLightSuccess60",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "60"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "60"
            ]
          },
          "70": {
            "value": "#0fdc8e",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#0FDC8E"
            },
            "name": "ColorRefLightSuccess70",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "70"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "70"
            ]
          },
          "80": {
            "value": "#3feca9",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#3FECA9"
            },
            "name": "ColorRefLightSuccess80",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "80"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "80"
            ]
          },
          "90": {
            "value": "#7af7c7",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#7AF7C7"
            },
            "name": "ColorRefLightSuccess90",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "90"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "90"
            ]
          },
          "95": {
            "value": "#bcfde4",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#BCFDE4"
            },
            "name": "ColorRefLightSuccess95",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "95"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "95"
            ]
          },
          "99": {
            "value": "#defef2",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#DEFEF2"
            },
            "name": "ColorRefLightSuccess99",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "99"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "99"
            ]
          },
          "100": {
            "value": "#ffffff",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FFFFFF"
            },
            "name": "ColorRefLightSuccess100",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "success",
              "state": "100"
            },
            "path": [
              "color",
              "ref",
              "light",
              "success",
              "100"
            ]
          }
        },
        "warning": {
          "5": {
            "value": "#191000",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#191000"
            },
            "name": "ColorRefLightWarning5",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "5"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "5"
            ]
          },
          "10": {
            "value": "#342000",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#342000"
            },
            "name": "ColorRefLightWarning10",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "10"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "10"
            ]
          },
          "20": {
            "value": "#533300",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#533300"
            },
            "name": "ColorRefLightWarning20",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "20"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "20"
            ]
          },
          "30": {
            "value": "#744700",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#744700"
            },
            "name": "ColorRefLightWarning30",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "30"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "30"
            ]
          },
          "40": {
            "value": "#935b00",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#935B00"
            },
            "name": "ColorRefLightWarning40",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "40"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "40"
            ]
          },
          "50": {
            "value": "#af6c00",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#AF6C00"
            },
            "name": "ColorRefLightWarning50",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "50"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "50"
            ]
          },
          "60": {
            "value": "#c87b00",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#C87B00"
            },
            "name": "ColorRefLightWarning60",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "60"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "60"
            ]
          },
          "70": {
            "value": "#dc8e0f",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#DC8E0F"
            },
            "name": "ColorRefLightWarning70",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "70"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "70"
            ]
          },
          "80": {
            "value": "#eca93f",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#ECA93F"
            },
            "name": "ColorRefLightWarning80",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "80"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "80"
            ]
          },
          "90": {
            "value": "#f7c77a",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#F7C77A"
            },
            "name": "ColorRefLightWarning90",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "90"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "90"
            ]
          },
          "95": {
            "value": "#fde4bc",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FDE4BC"
            },
            "name": "ColorRefLightWarning95",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "95"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "95"
            ]
          },
          "99": {
            "value": "#fef2de",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FEF2DE"
            },
            "name": "ColorRefLightWarning99",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "99"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "99"
            ]
          },
          "100": {
            "value": "#ffffff",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FFFFFF"
            },
            "name": "ColorRefLightWarning100",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "warning",
              "state": "100"
            },
            "path": [
              "color",
              "ref",
              "light",
              "warning",
              "100"
            ]
          }
        },
        "danger": {
          "5": {
            "value": "#190000",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#190000"
            },
            "name": "ColorRefLightDanger5",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "5"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "5"
            ]
          },
          "10": {
            "value": "#340001",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#340001"
            },
            "name": "ColorRefLightDanger10",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "10"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "10"
            ]
          },
          "20": {
            "value": "#530001",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#530001"
            },
            "name": "ColorRefLightDanger20",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "20"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "20"
            ]
          },
          "30": {
            "value": "#740002",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#740002"
            },
            "name": "ColorRefLightDanger30",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "30"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "30"
            ]
          },
          "40": {
            "value": "#930002",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#930002"
            },
            "name": "ColorRefLightDanger40",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "40"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "40"
            ]
          },
          "50": {
            "value": "#af0003",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#AF0003"
            },
            "name": "ColorRefLightDanger50",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "50"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "50"
            ]
          },
          "60": {
            "value": "#c80003",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#C80003"
            },
            "name": "ColorRefLightDanger60",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "60"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "60"
            ]
          },
          "70": {
            "value": "#dc0f13",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#DC0F13"
            },
            "name": "ColorRefLightDanger70",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "70"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "70"
            ]
          },
          "80": {
            "value": "#ec3f41",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#EC3F41"
            },
            "name": "ColorRefLightDanger80",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "80"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "80"
            ]
          },
          "90": {
            "value": "#f77a7c",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#F77A7C"
            },
            "name": "ColorRefLightDanger90",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "90"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "90"
            ]
          },
          "95": {
            "value": "#fdbcbd",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FDBCBD"
            },
            "name": "ColorRefLightDanger95",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "95"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "95"
            ]
          },
          "99": {
            "value": "#fedede",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FEDEDE"
            },
            "name": "ColorRefLightDanger99",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "99"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "99"
            ]
          },
          "100": {
            "value": "#ffffff",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FFFFFF"
            },
            "name": "ColorRefLightDanger100",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "danger",
              "state": "100"
            },
            "path": [
              "color",
              "ref",
              "light",
              "danger",
              "100"
            ]
          }
        },
        "neutral": {
          "5": {
            "value": "#0a0a0a",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#0A0A0A"
            },
            "name": "ColorRefLightNeutral5",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "5"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "5"
            ]
          },
          "10": {
            "value": "#1f2020",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#1F2020"
            },
            "name": "ColorRefLightNeutral10",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "10"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "10"
            ]
          },
          "20": {
            "value": "#343537",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#343537"
            },
            "name": "ColorRefLightNeutral20",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "20"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "20"
            ]
          },
          "30": {
            "value": "#494b4d",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#494B4D"
            },
            "name": "ColorRefLightNeutral30",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "30"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "30"
            ]
          },
          "40": {
            "value": "#5e6163",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#5E6163"
            },
            "name": "ColorRefLightNeutral40",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "40"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "40"
            ]
          },
          "50": {
            "value": "#747779",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#747779"
            },
            "name": "ColorRefLightNeutral50",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "50"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "50"
            ]
          },
          "60": {
            "value": "#8a8d90",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#8A8D90"
            },
            "name": "ColorRefLightNeutral60",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "60"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "60"
            ]
          },
          "70": {
            "value": "#a0a3a6",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#A0A3A6"
            },
            "name": "ColorRefLightNeutral70",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "70"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "70"
            ]
          },
          "80": {
            "value": "#b7babc",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#B7BABC"
            },
            "name": "ColorRefLightNeutral80",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "80"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "80"
            ]
          },
          "90": {
            "value": "#cfd1d2",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#CFD1D2"
            },
            "name": "ColorRefLightNeutral90",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "90"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "90"
            ]
          },
          "95": {
            "value": "#e7e8e9",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#E7E8E9"
            },
            "name": "ColorRefLightNeutral95",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "95"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "95"
            ]
          },
          "97": {
            "value": "#f5f5f5",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#F5F5F5"
            },
            "name": "ColorRefLightNeutral97",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "97"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "97"
            ]
          },
          "99": {
            "value": "#fafafa",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FAFAFA"
            },
            "name": "ColorRefLightNeutral99",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "99"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "99"
            ]
          },
          "100": {
            "value": "#ffffff",
            "filePath": "src/color/ref.json",
            "isSource": true,
            "original": {
              "value": "#FFFFFF"
            },
            "name": "ColorRefLightNeutral100",
            "attributes": {
              "category": "color",
              "type": "ref",
              "item": "light",
              "subitem": "neutral",
              "state": "100"
            },
            "path": [
              "color",
              "ref",
              "light",
              "neutral",
              "100"
            ]
          }
        }
      }
    },
    "sys": {
      "light": {
        "primary": {
          "surface": {
            "value": "#deeffe",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.99}"
            },
            "name": "ColorSysLightPrimarySurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#7abcf7",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.90}"
            },
            "name": "ColorSysLightPrimarySurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#006bc8",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.60}"
            },
            "name": "ColorSysLightPrimaryInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#004e93",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.40}"
            },
            "name": "ColorSysLightPrimaryInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#003e74",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.30}"
            },
            "name": "ColorSysLightPrimaryInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#002c53",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.20}"
            },
            "name": "ColorSysLightPrimaryTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#000e19",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.5}"
            },
            "name": "ColorSysLightPrimaryTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "primary",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "light",
              "primary",
              "text-high"
            ]
          }
        },
        "success": {
          "surface": {
            "value": "#defef2",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.99}"
            },
            "name": "ColorSysLightSuccessSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#7af7c7",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.90}"
            },
            "name": "ColorSysLightSuccessSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#00c87b",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.60}"
            },
            "name": "ColorSysLightSuccessInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#00935b",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.40}"
            },
            "name": "ColorSysLightSuccessInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#007447",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.30}"
            },
            "name": "ColorSysLightSuccessInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#005333",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.20}"
            },
            "name": "ColorSysLightSuccessTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#001910",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.5}"
            },
            "name": "ColorSysLightSuccessTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "success",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "light",
              "success",
              "text-high"
            ]
          }
        },
        "warning": {
          "surface": {
            "value": "#fef2de",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.99}"
            },
            "name": "ColorSysLightWarningSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#f7c77a",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.90}"
            },
            "name": "ColorSysLightWarningSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#c87b00",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.60}"
            },
            "name": "ColorSysLightWarningInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#935b00",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.40}"
            },
            "name": "ColorSysLightWarningInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#744700",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.30}"
            },
            "name": "ColorSysLightWarningInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#533300",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.20}"
            },
            "name": "ColorSysLightWarningTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#191000",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.5}"
            },
            "name": "ColorSysLightWarningTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "warning",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "light",
              "warning",
              "text-high"
            ]
          }
        },
        "danger": {
          "surface": {
            "value": "#fedede",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.99}"
            },
            "name": "ColorSysLightDangerSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#f77a7c",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.90}"
            },
            "name": "ColorSysLightDangerSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#c80003",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.60}"
            },
            "name": "ColorSysLightDangerInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#930002",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.40}"
            },
            "name": "ColorSysLightDangerInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#740002",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.30}"
            },
            "name": "ColorSysLightDangerInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#530001",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.20}"
            },
            "name": "ColorSysLightDangerTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#190000",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.5}"
            },
            "name": "ColorSysLightDangerTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "danger",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "light",
              "danger",
              "text-high"
            ]
          }
        },
        "neutral": {
          "background": {
            "value": "#ffffff",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.100}"
            },
            "name": "ColorSysLightNeutralBackground",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "background"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "background"
            ]
          },
          "surface": {
            "value": "#fafafa",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.99}"
            },
            "name": "ColorSysLightNeutralSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "surface"
            ]
          },
          "surface-disabled": {
            "value": "#e7e8e9",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.95}"
            },
            "name": "ColorSysLightNeutralSurfaceDisabled",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "surface-disabled"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "surface-disabled"
            ]
          },
          "surface-highlight": {
            "value": "#cfd1d2",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.90}"
            },
            "name": "ColorSysLightNeutralSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#b7babc",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.80}"
            },
            "name": "ColorSysLightNeutralInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#a0a3a6",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.70}"
            },
            "name": "ColorSysLightNeutralInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#8a8d90",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.60}"
            },
            "name": "ColorSysLightNeutralInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "interactive-pressed"
            ]
          },
          "text-disabled": {
            "value": "#5e6163",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.40}"
            },
            "name": "ColorSysLightNeutralTextDisabled",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "text-disabled"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "text-disabled"
            ]
          },
          "text-low": {
            "value": "#343537",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.20}"
            },
            "name": "ColorSysLightNeutralTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#0a0a0a",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.5}"
            },
            "name": "ColorSysLightNeutralTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "light",
              "subitem": "neutral",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "light",
              "neutral",
              "text-high"
            ]
          }
        }
      },
      "dark": {
        "primary": {
          "surface": {
            "value": "#001c34",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.10}"
            },
            "name": "ColorSysDarkPrimarySurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#003e74",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.30}"
            },
            "name": "ColorSysDarkPrimarySurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#0f7ddc",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.70}"
            },
            "name": "ColorSysDarkPrimaryInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#3f9bec",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.80}"
            },
            "name": "ColorSysDarkPrimaryInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#7abcf7",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.90}"
            },
            "name": "ColorSysDarkPrimaryInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#bcdffd",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.95}"
            },
            "name": "ColorSysDarkPrimaryTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#ffffff",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.primary.100}"
            },
            "name": "ColorSysDarkPrimaryTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "primary",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "primary",
              "text-high"
            ]
          }
        },
        "success": {
          "surface": {
            "value": "#003420",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.10}"
            },
            "name": "ColorSysDarkSuccessSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#007447",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.30}"
            },
            "name": "ColorSysDarkSuccessSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#0fdc8e",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.70}"
            },
            "name": "ColorSysDarkSuccessInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#3feca9",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.80}"
            },
            "name": "ColorSysDarkSuccessInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#7af7c7",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.90}"
            },
            "name": "ColorSysDarkSuccessInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#bcfde4",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.95}"
            },
            "name": "ColorSysDarkSuccessTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#ffffff",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.success.100}"
            },
            "name": "ColorSysDarkSuccessTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "success",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "success",
              "text-high"
            ]
          }
        },
        "warning": {
          "surface": {
            "value": "#342000",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.10}"
            },
            "name": "ColorSysDarkWarningSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#744700",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.30}"
            },
            "name": "ColorSysDarkWarningSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#dc8e0f",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.70}"
            },
            "name": "ColorSysDarkWarningInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#eca93f",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.80}"
            },
            "name": "ColorSysDarkWarningInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#f7c77a",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.90}"
            },
            "name": "ColorSysDarkWarningInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#fde4bc",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.95}"
            },
            "name": "ColorSysDarkWarningTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#ffffff",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.warning.100}"
            },
            "name": "ColorSysDarkWarningTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "warning",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "warning",
              "text-high"
            ]
          }
        },
        "danger": {
          "surface": {
            "value": "#340001",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.10}"
            },
            "name": "ColorSysDarkDangerSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "surface"
            ]
          },
          "surface-highlight": {
            "value": "#740002",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.30}"
            },
            "name": "ColorSysDarkDangerSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#dc0f13",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.70}"
            },
            "name": "ColorSysDarkDangerInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#ec3f41",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.80}"
            },
            "name": "ColorSysDarkDangerInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#f77a7c",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.90}"
            },
            "name": "ColorSysDarkDangerInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "interactive-pressed"
            ]
          },
          "text-low": {
            "value": "#fdbcbd",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.95}"
            },
            "name": "ColorSysDarkDangerTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#ffffff",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.danger.100}"
            },
            "name": "ColorSysDarkDangerTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "danger",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "danger",
              "text-high"
            ]
          }
        },
        "neutral": {
          "background": {
            "value": "#0a0a0a",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.5}"
            },
            "name": "ColorSysDarkNeutralBackground",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "background"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "background"
            ]
          },
          "surface": {
            "value": "#1f2020",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.10}"
            },
            "name": "ColorSysDarkNeutralSurface",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "surface"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "surface"
            ]
          },
          "surface-disabled": {
            "value": "#343537",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.20}"
            },
            "name": "ColorSysDarkNeutralSurfaceDisabled",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "surface-disabled"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "surface-disabled"
            ]
          },
          "surface-highlight": {
            "value": "#494b4d",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.30}"
            },
            "name": "ColorSysDarkNeutralSurfaceHighlight",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "surface-highlight"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "surface-highlight"
            ]
          },
          "interactive": {
            "value": "#5e6163",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.40}"
            },
            "name": "ColorSysDarkNeutralInteractive",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "interactive"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "interactive"
            ]
          },
          "interactive-hover": {
            "value": "#747779",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.50}"
            },
            "name": "ColorSysDarkNeutralInteractiveHover",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "interactive-hover"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "interactive-hover"
            ]
          },
          "interactive-pressed": {
            "value": "#8a8d90",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.60}"
            },
            "name": "ColorSysDarkNeutralInteractivePressed",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "interactive-pressed"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "interactive-pressed"
            ]
          },
          "text-disabled": {
            "value": "#b7babc",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.80}"
            },
            "name": "ColorSysDarkNeutralTextDisabled",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "text-disabled"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "text-disabled"
            ]
          },
          "text-low": {
            "value": "#e7e8e9",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.95}"
            },
            "name": "ColorSysDarkNeutralTextLow",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "text-low"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "text-low"
            ]
          },
          "text-high": {
            "value": "#ffffff",
            "filePath": "src/color/sys.json",
            "isSource": true,
            "original": {
              "value": "{color.ref.light.neutral.100}"
            },
            "name": "ColorSysDarkNeutralTextHigh",
            "attributes": {
              "category": "color",
              "type": "sys",
              "item": "dark",
              "subitem": "neutral",
              "state": "text-high"
            },
            "path": [
              "color",
              "sys",
              "dark",
              "neutral",
              "text-high"
            ]
          }
        }
      }
    }
  },
  "motion": {
    "speed": {
      "fast": {
        "value": "150ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "150ms"
        },
        "name": "MotionSpeedFast",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "fast"
        },
        "path": [
          "motion",
          "speed",
          "fast"
        ]
      },
      "base": {
        "value": "300ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "300ms"
        },
        "name": "MotionSpeedBase",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "base"
        },
        "path": [
          "motion",
          "speed",
          "base"
        ]
      },
      "slow": {
        "value": "450ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "450ms"
        },
        "name": "MotionSpeedSlow",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "slow"
        },
        "path": [
          "motion",
          "speed",
          "slow"
        ]
      },
      "slower": {
        "value": "600ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "600ms"
        },
        "name": "MotionSpeedSlower",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "slower"
        },
        "path": [
          "motion",
          "speed",
          "slower"
        ]
      }
    }
  },
  "shadow": {
    "level": {
      "0": {
        "value": "none",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "none"
        },
        "name": "ShadowLevel0",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "0"
        },
        "path": [
          "shadow",
          "level",
          "0"
        ]
      },
      "1": {
        "value": "0px 0px 1px 0px #b7babc",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 0px 1px 0px {color.sys.light.neutral.interactive}"
        },
        "name": "ShadowLevel1",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "1"
        },
        "path": [
          "shadow",
          "level",
          "1"
        ]
      },
      "2": {
        "value": "0px 0px 2px 0px #cfd1d2, 0px 1px 1px 0px #cfd1d2",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 0px 2px 0px {color.sys.light.neutral.surface-highlight}, 0px 1px 1px 0px {color.sys.light.neutral.surface-highlight}"
        },
        "name": "ShadowLevel2",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "2"
        },
        "path": [
          "shadow",
          "level",
          "2"
        ]
      },
      "3": {
        "value": "0px 2px 4px 0px #cfd1d2, 0px 0px 1px 0px #cfd1d2",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 2px 4px 0px {color.sys.light.neutral.surface-highlight}, 0px 0px 1px 0px {color.sys.light.neutral.surface-highlight}"
        },
        "name": "ShadowLevel3",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "3"
        },
        "path": [
          "shadow",
          "level",
          "3"
        ]
      },
      "4": {
        "value": "0px 12px 16px 0px #cfd1d2, 0px 0px 1px 0px #cfd1d2",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 12px 16px 0px {color.sys.light.neutral.surface-highlight}, 0px 0px 1px 0px {color.sys.light.neutral.surface-highlight}"
        },
        "name": "ShadowLevel4",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "4"
        },
        "path": [
          "shadow",
          "level",
          "4"
        ]
      },
      "5": {
        "value": "0px 24px 32px 0px #cfd1d2, 0px 0px 1px 0px #cfd1d2",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 24px 32px 0px {color.sys.light.neutral.surface-highlight}, 0px 0px 1px 0px {color.sys.light.neutral.surface-highlight}"
        },
        "name": "ShadowLevel5",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "5"
        },
        "path": [
          "shadow",
          "level",
          "5"
        ]
      }
    },
    "light": {
      "level": {
        "0": {
          "value": "none",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.0}"
          },
          "name": "ShadowLightLevel0",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "0"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "0"
          ]
        },
        "1": {
          "value": "0px 0px 1px 0px #b7babc",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.1}"
          },
          "name": "ShadowLightLevel1",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "1"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "1"
          ]
        },
        "2": {
          "value": "0px 0px 2px 0px #cfd1d2, 0px 1px 1px 0px #cfd1d2",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.2}"
          },
          "name": "ShadowLightLevel2",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "2"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "2"
          ]
        },
        "3": {
          "value": "0px 2px 4px 0px #cfd1d2, 0px 0px 1px 0px #cfd1d2",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.3}"
          },
          "name": "ShadowLightLevel3",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "3"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "3"
          ]
        },
        "4": {
          "value": "0px 12px 16px 0px #cfd1d2, 0px 0px 1px 0px #cfd1d2",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.4}"
          },
          "name": "ShadowLightLevel4",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "4"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "4"
          ]
        },
        "5": {
          "value": "0px 24px 32px 0px #cfd1d2, 0px 0px 1px 0px #cfd1d2",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.5}"
          },
          "name": "ShadowLightLevel5",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "5"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "5"
          ]
        }
      }
    },
    "dark": {
      "level": {
        "0": {
          "value": "none",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "none"
          },
          "name": "ShadowDarkLevel0",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "0"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "0"
          ]
        },
        "1": {
          "value": "0px 0px 1px 0px #5e6163",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 0px 1px 0px {color.sys.dark.neutral.interactive}"
          },
          "name": "ShadowDarkLevel1",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "1"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "1"
          ]
        },
        "2": {
          "value": "0px 0px 2px 0px #494b4d, 0px 1px 1px 0px #494b4d",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 0px 2px 0px {color.sys.dark.neutral.surface-highlight}, 0px 1px 1px 0px {color.sys.dark.neutral.surface-highlight}"
          },
          "name": "ShadowDarkLevel2",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "2"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "2"
          ]
        },
        "3": {
          "value": "0px 2px 4px 0px #494b4d, 0px 0px 1px 0px #494b4d",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 2px 4px 0px {color.sys.dark.neutral.surface-highlight}, 0px 0px 1px 0px {color.sys.dark.neutral.surface-highlight}"
          },
          "name": "ShadowDarkLevel3",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "3"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "3"
          ]
        },
        "4": {
          "value": "0px 12px 16px 0px #494b4d, 0px 0px 1px 0px #494b4d",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 12px 16px 0px {color.sys.dark.neutral.surface-highlight}, 0px 0px 1px 0px {color.sys.dark.neutral.surface-highlight}"
          },
          "name": "ShadowDarkLevel4",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "4"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "4"
          ]
        },
        "5": {
          "value": "0px 24px 32px 0px #494b4d, 0px 0px 1px 0px #494b4d",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 24px 32px 0px {color.sys.dark.neutral.surface-highlight}, 0px 0px 1px 0px {color.sys.dark.neutral.surface-highlight}"
          },
          "name": "ShadowDarkLevel5",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "5"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "5"
          ]
        }
      }
    }
  },
  "shape": {
    "border": {
      "radius": {
        "1": {
          "value": "0.25rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.1}"
          },
          "name": "ShapeBorderRadius1",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "1"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "1"
          ]
        },
        "2": {
          "value": "0.5rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.2}"
          },
          "name": "ShapeBorderRadius2",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "2"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "2"
          ]
        },
        "3": {
          "value": "0.75rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.3}"
          },
          "name": "ShapeBorderRadius3",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "3"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "3"
          ]
        },
        "4": {
          "value": "1rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.4}"
          },
          "name": "ShapeBorderRadius4",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "4"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "4"
          ]
        },
        "5": {
          "value": "1.25rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.5}"
          },
          "name": "ShapeBorderRadius5",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "5"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "5"
          ]
        },
        "6": {
          "value": "1.5rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.6}"
          },
          "name": "ShapeBorderRadius6",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "6"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "6"
          ]
        },
        "0,5": {
          "value": "0.125rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.0,5}"
          },
          "name": "ShapeBorderRadius05",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "0,5"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "0,5"
          ]
        },
        "full": {
          "value": "9999px",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "9999px"
          },
          "name": "ShapeBorderRadiusFull",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "full"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "full"
          ]
        },
        "base": {
          "value": "0.375rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{sizes.1,5}"
          },
          "name": "ShapeBorderRadiusBase",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "base"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "base"
          ]
        },
        "half": {
          "value": "50%",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "50%"
          },
          "name": "ShapeBorderRadiusHalf",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "half"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "half"
          ]
        }
      },
      "width": {
        "1": {
          "value": "0.0625rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.0625rem"
          },
          "name": "ShapeBorderWidth1",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "1"
          },
          "path": [
            "shape",
            "border",
            "width",
            "1"
          ]
        },
        "2": {
          "value": "0.125rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.125rem"
          },
          "name": "ShapeBorderWidth2",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "2"
          },
          "path": [
            "shape",
            "border",
            "width",
            "2"
          ]
        },
        "3": {
          "value": "0.1875rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.1875rem"
          },
          "name": "ShapeBorderWidth3",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "3"
          },
          "path": [
            "shape",
            "border",
            "width",
            "3"
          ]
        },
        "4": {
          "value": "1rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "1rem"
          },
          "name": "ShapeBorderWidth4",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "4"
          },
          "path": [
            "shape",
            "border",
            "width",
            "4"
          ]
        },
        "5": {
          "value": "0.3125rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.3125rem"
          },
          "name": "ShapeBorderWidth5",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "5"
          },
          "path": [
            "shape",
            "border",
            "width",
            "5"
          ]
        }
      }
    }
  },
  "sizes": {
    "1": {
      "value": "0.25rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.25rem"
      },
      "name": "Sizes1",
      "attributes": {
        "category": "sizes",
        "type": "1"
      },
      "path": [
        "sizes",
        "1"
      ]
    },
    "2": {
      "value": "0.5rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.5rem"
      },
      "name": "Sizes2",
      "attributes": {
        "category": "sizes",
        "type": "2"
      },
      "path": [
        "sizes",
        "2"
      ]
    },
    "3": {
      "value": "0.75rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.75rem"
      },
      "name": "Sizes3",
      "attributes": {
        "category": "sizes",
        "type": "3"
      },
      "path": [
        "sizes",
        "3"
      ]
    },
    "4": {
      "value": "1rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "1rem"
      },
      "name": "Sizes4",
      "attributes": {
        "category": "sizes",
        "type": "4"
      },
      "path": [
        "sizes",
        "4"
      ]
    },
    "5": {
      "value": "1.25rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "1.25rem"
      },
      "name": "Sizes5",
      "attributes": {
        "category": "sizes",
        "type": "5"
      },
      "path": [
        "sizes",
        "5"
      ]
    },
    "6": {
      "value": "1.5rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "1.5rem"
      },
      "name": "Sizes6",
      "attributes": {
        "category": "sizes",
        "type": "6"
      },
      "path": [
        "sizes",
        "6"
      ]
    },
    "7": {
      "value": "1.75rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "1.75rem"
      },
      "name": "Sizes7",
      "attributes": {
        "category": "sizes",
        "type": "7"
      },
      "path": [
        "sizes",
        "7"
      ]
    },
    "8": {
      "value": "2rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "2rem"
      },
      "name": "Sizes8",
      "attributes": {
        "category": "sizes",
        "type": "8"
      },
      "path": [
        "sizes",
        "8"
      ]
    },
    "9": {
      "value": "2.25rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "2.25rem"
      },
      "name": "Sizes9",
      "attributes": {
        "category": "sizes",
        "type": "9"
      },
      "path": [
        "sizes",
        "9"
      ]
    },
    "10": {
      "value": "2.5rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "2.5rem"
      },
      "name": "Sizes10",
      "attributes": {
        "category": "sizes",
        "type": "10"
      },
      "path": [
        "sizes",
        "10"
      ]
    },
    "11": {
      "value": "2.75rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "2.75rem"
      },
      "name": "Sizes11",
      "attributes": {
        "category": "sizes",
        "type": "11"
      },
      "path": [
        "sizes",
        "11"
      ]
    },
    "12": {
      "value": "3rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "3rem"
      },
      "name": "Sizes12",
      "attributes": {
        "category": "sizes",
        "type": "12"
      },
      "path": [
        "sizes",
        "12"
      ]
    },
    "14": {
      "value": "3.5rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "3.5rem"
      },
      "name": "Sizes14",
      "attributes": {
        "category": "sizes",
        "type": "14"
      },
      "path": [
        "sizes",
        "14"
      ]
    },
    "16": {
      "value": "4rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "4rem"
      },
      "name": "Sizes16",
      "attributes": {
        "category": "sizes",
        "type": "16"
      },
      "path": [
        "sizes",
        "16"
      ]
    },
    "18": {
      "value": "4.5rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "4.5rem"
      },
      "name": "Sizes18",
      "attributes": {
        "category": "sizes",
        "type": "18"
      },
      "path": [
        "sizes",
        "18"
      ]
    },
    "20": {
      "value": "5rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "5rem"
      },
      "name": "Sizes20",
      "attributes": {
        "category": "sizes",
        "type": "20"
      },
      "path": [
        "sizes",
        "20"
      ]
    },
    "0,5": {
      "value": "0.125rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.125rem"
      },
      "name": "Sizes05",
      "attributes": {
        "category": "sizes",
        "type": "0,5"
      },
      "path": [
        "sizes",
        "0,5"
      ]
    },
    "1,5": {
      "value": "0.375rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.375rem"
      },
      "name": "Sizes15",
      "attributes": {
        "category": "sizes",
        "type": "1,5"
      },
      "path": [
        "sizes",
        "1,5"
      ]
    },
    "2,5": {
      "value": "0.625rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.625rem"
      },
      "name": "Sizes25",
      "attributes": {
        "category": "sizes",
        "type": "2,5"
      },
      "path": [
        "sizes",
        "2,5"
      ]
    },
    "3,5": {
      "value": "0.875rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "0.875rem"
      },
      "name": "Sizes35",
      "attributes": {
        "category": "sizes",
        "type": "3,5"
      },
      "path": [
        "sizes",
        "3,5"
      ]
    },
    "4,5": {
      "value": "1.125rem",
      "filePath": "src/sizes/ref.json",
      "isSource": true,
      "original": {
        "value": "1.125rem"
      },
      "name": "Sizes45",
      "attributes": {
        "category": "sizes",
        "type": "4,5"
      },
      "path": [
        "sizes",
        "4,5"
      ]
    }
  },
  "spacing": {
    "1": {
      "value": "0.25rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.1}"
      },
      "name": "Spacing1",
      "attributes": {
        "category": "spacing",
        "type": "1"
      },
      "path": [
        "spacing",
        "1"
      ]
    },
    "2": {
      "value": "0.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.2}"
      },
      "name": "Spacing2",
      "attributes": {
        "category": "spacing",
        "type": "2"
      },
      "path": [
        "spacing",
        "2"
      ]
    },
    "4": {
      "value": "1rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.4}"
      },
      "name": "Spacing4",
      "attributes": {
        "category": "spacing",
        "type": "4"
      },
      "path": [
        "spacing",
        "4"
      ]
    },
    "6": {
      "value": "1.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.6}"
      },
      "name": "Spacing6",
      "attributes": {
        "category": "spacing",
        "type": "6"
      },
      "path": [
        "spacing",
        "6"
      ]
    },
    "8": {
      "value": "2rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.8}"
      },
      "name": "Spacing8",
      "attributes": {
        "category": "spacing",
        "type": "8"
      },
      "path": [
        "spacing",
        "8"
      ]
    },
    "10": {
      "value": "2.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.10}"
      },
      "name": "Spacing10",
      "attributes": {
        "category": "spacing",
        "type": "10"
      },
      "path": [
        "spacing",
        "10"
      ]
    },
    "12": {
      "value": "3rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.12}"
      },
      "name": "Spacing12",
      "attributes": {
        "category": "spacing",
        "type": "12"
      },
      "path": [
        "spacing",
        "12"
      ]
    },
    "14": {
      "value": "3.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.14}"
      },
      "name": "Spacing14",
      "attributes": {
        "category": "spacing",
        "type": "14"
      },
      "path": [
        "spacing",
        "14"
      ]
    },
    "16": {
      "value": "4rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.16}"
      },
      "name": "Spacing16",
      "attributes": {
        "category": "spacing",
        "type": "16"
      },
      "path": [
        "spacing",
        "16"
      ]
    },
    "18": {
      "value": "4.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.18}"
      },
      "name": "Spacing18",
      "attributes": {
        "category": "spacing",
        "type": "18"
      },
      "path": [
        "spacing",
        "18"
      ]
    },
    "20": {
      "value": "5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.20}"
      },
      "name": "Spacing20",
      "attributes": {
        "category": "spacing",
        "type": "20"
      },
      "path": [
        "spacing",
        "20"
      ]
    },
    "0,5": {
      "value": "0.125rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "{sizes.0,5}"
      },
      "name": "Spacing05",
      "attributes": {
        "category": "spacing",
        "type": "0,5"
      },
      "path": [
        "spacing",
        "0,5"
      ]
    }
  },
  "font": {
    "size": {
      "ref": {
        "3": {
          "value": "0.75rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.3}"
          },
          "name": "FontSizeRef3",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "3"
          },
          "path": [
            "font",
            "size",
            "ref",
            "3"
          ]
        },
        "4": {
          "value": "1rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.4}"
          },
          "name": "FontSizeRef4",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "4"
          },
          "path": [
            "font",
            "size",
            "ref",
            "4"
          ]
        },
        "5": {
          "value": "1.25rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.5}"
          },
          "name": "FontSizeRef5",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "5"
          },
          "path": [
            "font",
            "size",
            "ref",
            "5"
          ]
        },
        "6": {
          "value": "1.5rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.6}"
          },
          "name": "FontSizeRef6",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "6"
          },
          "path": [
            "font",
            "size",
            "ref",
            "6"
          ]
        },
        "8": {
          "value": "2rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.8}"
          },
          "name": "FontSizeRef8",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "8"
          },
          "path": [
            "font",
            "size",
            "ref",
            "8"
          ]
        },
        "12": {
          "value": "3rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.12}"
          },
          "name": "FontSizeRef12",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "12"
          },
          "path": [
            "font",
            "size",
            "ref",
            "12"
          ]
        },
        "16": {
          "value": "4rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.16}"
          },
          "name": "FontSizeRef16",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "16"
          },
          "path": [
            "font",
            "size",
            "ref",
            "16"
          ]
        },
        "3,5": {
          "value": "0.875rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.3,5}"
          },
          "name": "FontSizeRef35",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "3,5"
          },
          "path": [
            "font",
            "size",
            "ref",
            "3,5"
          ]
        },
        "4,5": {
          "value": "1.125rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.4,5}"
          },
          "name": "FontSizeRef45",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "ref",
            "subitem": "4,5"
          },
          "path": [
            "font",
            "size",
            "ref",
            "4,5"
          ]
        }
      },
      "sys": {
        "body": {
          "caption": {
            "value": "0.75rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.3}"
            },
            "name": "FontSizeSysBodyCaption",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "body",
              "state": "caption"
            },
            "path": [
              "font",
              "size",
              "sys",
              "body",
              "caption"
            ]
          },
          "base": {
            "value": "0.875rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.3,5}"
            },
            "name": "FontSizeSysBodyBase",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "body",
              "state": "base"
            },
            "path": [
              "font",
              "size",
              "sys",
              "body",
              "base"
            ]
          },
          "highlight": {
            "value": "1rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.4}"
            },
            "name": "FontSizeSysBodyHighlight",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "body",
              "state": "highlight"
            },
            "path": [
              "font",
              "size",
              "sys",
              "body",
              "highlight"
            ]
          }
        },
        "title": {
          "h1": {
            "value": "2rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.8}"
            },
            "name": "FontSizeSysTitleH1",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "title",
              "state": "h1"
            },
            "path": [
              "font",
              "size",
              "sys",
              "title",
              "h1"
            ]
          },
          "h2": {
            "value": "1.5rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.6}"
            },
            "name": "FontSizeSysTitleH2",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "title",
              "state": "h2"
            },
            "path": [
              "font",
              "size",
              "sys",
              "title",
              "h2"
            ]
          },
          "h3": {
            "value": "1.25rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.5}"
            },
            "name": "FontSizeSysTitleH3",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "title",
              "state": "h3"
            },
            "path": [
              "font",
              "size",
              "sys",
              "title",
              "h3"
            ]
          },
          "h4": {
            "value": "1.125rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.4,5}"
            },
            "name": "FontSizeSysTitleH4",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "title",
              "state": "h4"
            },
            "path": [
              "font",
              "size",
              "sys",
              "title",
              "h4"
            ]
          },
          "h5": {
            "value": "1rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.4}"
            },
            "name": "FontSizeSysTitleH5",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "title",
              "state": "h5"
            },
            "path": [
              "font",
              "size",
              "sys",
              "title",
              "h5"
            ]
          },
          "h6": {
            "value": "0.875rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{font.size.ref.3,5}"
            },
            "name": "FontSizeSysTitleH6",
            "attributes": {
              "category": "font",
              "type": "size",
              "item": "sys",
              "subitem": "title",
              "state": "h6"
            },
            "path": [
              "font",
              "size",
              "sys",
              "title",
              "h6"
            ]
          }
        }
      }
    },
    "family": {
      "value": "CentraNube, -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', arial, sans-serif",
      "filePath": "src/typography/sys.json",
      "isSource": true,
      "original": {
        "value": "CentraNube, -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', arial, sans-serif"
      },
      "name": "FontFamily",
      "attributes": {
        "category": "font",
        "type": "family"
      },
      "path": [
        "font",
        "family"
      ]
    },
    "weight": {
      "regular": {
        "value": "400",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "400"
        },
        "name": "FontWeightRegular",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "regular"
        },
        "path": [
          "font",
          "weight",
          "regular"
        ]
      },
      "medium": {
        "value": "500",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "500"
        },
        "name": "FontWeightMedium",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "medium"
        },
        "path": [
          "font",
          "weight",
          "medium"
        ]
      },
      "bold": {
        "value": "700",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "700"
        },
        "name": "FontWeightBold",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "bold"
        },
        "path": [
          "font",
          "weight",
          "bold"
        ]
      }
    }
  },
  "line": {
    "height": {
      "ref": {
        "4": {
          "value": "1rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.4}"
          },
          "name": "LineHeightRef4",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "4"
          },
          "path": [
            "line",
            "height",
            "ref",
            "4"
          ]
        },
        "5": {
          "value": "1.25rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.5}"
          },
          "name": "LineHeightRef5",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "5"
          },
          "path": [
            "line",
            "height",
            "ref",
            "5"
          ]
        },
        "6": {
          "value": "1.5rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.6}"
          },
          "name": "LineHeightRef6",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "6"
          },
          "path": [
            "line",
            "height",
            "ref",
            "6"
          ]
        },
        "7": {
          "value": "1.75rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.7}"
          },
          "name": "LineHeightRef7",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "7"
          },
          "path": [
            "line",
            "height",
            "ref",
            "7"
          ]
        },
        "8": {
          "value": "2rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.8}"
          },
          "name": "LineHeightRef8",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "8"
          },
          "path": [
            "line",
            "height",
            "ref",
            "8"
          ]
        },
        "11": {
          "value": "2.75rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.11}"
          },
          "name": "LineHeightRef11",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "11"
          },
          "path": [
            "line",
            "height",
            "ref",
            "11"
          ]
        },
        "3,5": {
          "value": "0.875rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.3,5}"
          },
          "name": "LineHeightRef35",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "3,5"
          },
          "path": [
            "line",
            "height",
            "ref",
            "3,5"
          ]
        },
        "4,5": {
          "value": "1.125rem",
          "filePath": "src/typography/ref.json",
          "isSource": true,
          "original": {
            "value": "{sizes.4,5}"
          },
          "name": "LineHeightRef45",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "ref",
            "subitem": "4,5"
          },
          "path": [
            "line",
            "height",
            "ref",
            "4,5"
          ]
        }
      },
      "sys": {
        "body": {
          "caption": {
            "value": "0.875rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.3,5}"
            },
            "name": "LineHeightSysBodyCaption",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "body",
              "state": "caption"
            },
            "path": [
              "line",
              "height",
              "sys",
              "body",
              "caption"
            ]
          },
          "base": {
            "value": "1.125rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.4,5}"
            },
            "name": "LineHeightSysBodyBase",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "body",
              "state": "base"
            },
            "path": [
              "line",
              "height",
              "sys",
              "body",
              "base"
            ]
          },
          "highlight": {
            "value": "1.25rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.5}"
            },
            "name": "LineHeightSysBodyHighlight",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "body",
              "state": "highlight"
            },
            "path": [
              "line",
              "height",
              "sys",
              "body",
              "highlight"
            ]
          }
        },
        "title": {
          "h1": {
            "value": "2.75rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.11}"
            },
            "name": "LineHeightSysTitleH1",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "title",
              "state": "h1"
            },
            "path": [
              "line",
              "height",
              "sys",
              "title",
              "h1"
            ]
          },
          "h2": {
            "value": "2rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.8}"
            },
            "name": "LineHeightSysTitleH2",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "title",
              "state": "h2"
            },
            "path": [
              "line",
              "height",
              "sys",
              "title",
              "h2"
            ]
          },
          "h3": {
            "value": "1.75rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.7}"
            },
            "name": "LineHeightSysTitleH3",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "title",
              "state": "h3"
            },
            "path": [
              "line",
              "height",
              "sys",
              "title",
              "h3"
            ]
          },
          "h4": {
            "value": "1.5rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.6}"
            },
            "name": "LineHeightSysTitleH4",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "title",
              "state": "h4"
            },
            "path": [
              "line",
              "height",
              "sys",
              "title",
              "h4"
            ]
          },
          "h5": {
            "value": "1.25rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.5}"
            },
            "name": "LineHeightSysTitleH5",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "title",
              "state": "h5"
            },
            "path": [
              "line",
              "height",
              "sys",
              "title",
              "h5"
            ]
          },
          "h6": {
            "value": "1.125rem",
            "filePath": "src/typography/sys.json",
            "isSource": true,
            "original": {
              "value": "{line.height.ref.4,5}"
            },
            "name": "LineHeightSysTitleH6",
            "attributes": {
              "category": "line",
              "type": "height",
              "item": "sys",
              "subitem": "title",
              "state": "h6"
            },
            "path": [
              "line",
              "height",
              "sys",
              "title",
              "h6"
            ]
          }
        }
      }
    }
  }
};